import apiInternal from './servers/apiInternal';

export interface CallbackItem {
  status: string;
  method: string;
  urlClient: string;
  retry: number;
  application: string;
  createdAt: string;
  timeToSendSeconds: number;
  file: string;
}

export interface ApiCallbackResponse {
  success: boolean;
  data: {
    externalId: string;
    callbacks: CallbackItem[];
  };
}

const apiCallback = {
  getCallback: async (id: string): Promise<ApiCallbackResponse> => {
    const res = await apiInternal.get(`/callback/${id}`);
    // O backend retorna { success: true, data: { externalId, callbacks: [...] } }
    if (res.data && res.data.success !== undefined && res.data.data) {
      return res.data;
    }
    // Fallback caso a resposta venha em formato diferente
    return {
      success: false,
      data: {
        externalId: id,
        callbacks: [],
      },
    };
  },
};

export default apiCallback;

